export const REPORT_TYPES = Object.freeze({
    PERFORMANCE: "0",
    SPECIFICITY: "1"
});